'use client'
import React from 'react';

import LogoSVG from '../public/assets/logo.svg';
import { DrupalMenuLinkContent } from 'next-drupal';
import Link from 'next/link';
import { IFrameCompact } from './iFrameCompact';

interface FooterProps {
    menu: DrupalMenuLinkContent[]
}

export const Footer = ({ menu }: FooterProps) => (
  <IFrameCompact>
    <footer>
        <div className='bg-white'>
            <div className='px-5 py-10 text-navy-600 container mx-auto'>
                <hr />
                <div className='py-10 gap-x-12 place-items-top grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4'>
                    <div className=''>
                        <LogoSVG className='me-1 fill-blue-600' />
                        <p>
                            53 State Street, 10th Floor<br />
                            Boston, MA 02109<br />
                            United States<br />
                            Phone: 888-922-7842
                        </p>
                        <Link href="https://support-acquia.force.com/s/contactsupport" target='_blank' rel='nofollow' className='print:hidden block bg-blue-600 hover:bg-blue-700 text-white p-5 text-center rounded'>Help Tickets</Link>
                    </div>
                    {menu.map(item => {
                        return (
                            <div key={item.id} className='print:hidden'>
                                <h4 className='font-bold text-lg'><Link rel='nofollow' target='_blank' href={item.url}>{item.title}</Link></h4>
                                <ul>
                                    {item.items?.map(i => {
                                        return <li key={i.id}><Link rel='nofollow' target='_blank' href={i.url}>{i.title}</Link></li>
                                    })}
                                </ul>
                            </div>
                        )
                    })}
                </div>
            
                <hr />
                <ul className='flex flex-row flex-wrap gap-x-5 container mx-auto'>
                    <li><a rel='nofollow' href="#">terms of service</a></li>
                    <li><a rel='nofollow' href="https://www.acquia.com/about-us/legal/privacy-policy">privacy policy</a></li>
                    <li><a rel='nofollow' href="https://www.acquia.com/about-us/legal">legal</a></li>
                    <li><a rel='nofollow' href="https://www.acquia.com/security">security</a></li>
                </ul>
            </div>
        </div>
    </footer>
  </IFrameCompact>
);
